import axios from '@/axios'
export const updatePhoneCheckLive = params =>
  axios.post('/amp/app/1.0/updatePhoneCheckLive', params)
